import { storeConstants } from '../constants';

export function storeRedu(state = {}, action) {
  switch (action.type) {
    case storeConstants.GETALL_SUCCESS:
    case storeConstants.DELETE_SUCCESS:
      return {
        type: action.type,
        stores: action.stores
      }

    case storeConstants.GETONE_SUCCESS:
    case storeConstants.CREATE_SUCCESS:
    case storeConstants.UPDATE_SUCCESS:
      return {
        type: action.type,
        store: action.store
      };

    case storeConstants.CREATE_FAILURE:
    case storeConstants.UPDATE_FAILURE:
    case storeConstants.GETONE_FAILURE:
    case storeConstants.DELETE_FAILURE:
    case storeConstants.GETALL_FAILURE:
      return {
        type: action.type,
        error: action.error
      }

    case  storeConstants.CLEAR:
      return {}

    case storeConstants.TOGGER_PROFILE:
      return {
        type: action.type,
        toggle: action.toggle
      }
    default:
      return state
  }
}
